import store from '../../redux/store';
import config from '../../../config';
import JSEncrypt from 'jsencrypt';


export const authconfig = (env, apiServiceName) => {

    let configs = {};
    if (env !== 'dev') {
        let { loginServiceReducer, amazonWebServicesReducer } = store.getState();
        let { awsCognito } = amazonWebServicesReducer;
        let id = null;
        let { idToken } = loginServiceReducer;
        id = idToken;
        if (!id) {
            let { idToken } = awsCognito;
            id = idToken && idToken.jwtToken;
        }
        const apiKey = JSON.parse(config.xApiKeyValues).find(keyVal => keyVal.key === apiServiceName)?.value ?? '';
        
        if (id) {
            configs = {
                headers: {
                    'x-api-key': apiKey,
                    'Authorization': `Bearer ${id}`
                }
            };
        } else {
            configs = {
                headers: {
                    'x-api-key': apiKey
                }
            };
        }

    }
    return configs;
}



export const encryptPassword = (password) => {
    const publicKey = process.env.PUBLIC_KEY;
    const crypt = new JSEncrypt();
    crypt.setPublicKey(publicKey);
    const encryption = crypt.encrypt(password);
    return encryption;
}





